module.exports = __webpack_public_path__ + "static/media/Silver.65f32043.svg";